export const HEADING_BACKGROUND_COLOR = Styles.color.highlight;
export const HEADING_COLOR = Styles.color.white;

export const SHOULD_CHECK_ITEM_IN_OFFER = true;

// this padding is needed so the IntersectionObserver can detect a new section being in view
// these are percentages
export const MOBILE_BLOCK_END_MENU_PADDING = 103;
export const DESKTOP_BLOCK_END_MENU_PADDING = 35;
